import { ohr } from 'utils/axios'

export const postWebsiteLead = payload =>
    ohr.post(`oh_www/website_lead`, payload)
